module.exports = __webpack_public_path__ + "static/media/S_S01.4f4ddf55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/S_S01.png
// module id = 135
// module chunks = 0